import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Stack, Input, Typography, InputAdornment } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import QuickStartErrorText from '../common/errorText';

interface CompanyNameTextFieldProps {
  value: string;
  setValue: (value: string) => void;
  verified: boolean;
  setVerified: (value: boolean) => void;
  error: string;
}

const CompanyNameTextField = ({
  value,
  setValue,
  verified,
  setVerified,
  error,
}: CompanyNameTextFieldProps) => {
  return (
    <Stack flexGrow={1} gap={0.5}>
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk, sans-serif',
          fontSize: '16px',
          fontWeight: 500,
          color: '#181818',
          lineHeight: '125%',
          marginBottom: '12px',
        }}
      >
        <FormattedMessage defaultMessage='Company Name' />
      </Typography>
      <Input
        id='companyName'
        name='companyName'
        disableUnderline
        fullWidth
        sx={{
          border: '1px solid #D1D1D1',
          borderRadius: '6px',
          padding: '10px 16px',
          '& .MuiInputBase-input': {
            fontFamily: 'Schibsted Grotesk, sans-serif',
            fontSize: '16px',
            fontWeight: 500,
            color: '#181818',
            lineHeight: '125%',
          },
          '&:focus-within': {
            border: '1px solid #000000',
          },
          ...(value.length > 0 && {
            backgroundColor: 'white!important',
            border: '1px solid black',
            '&:hover': {
              backgroundColor: 'white',
            },
          }),
        }}
        endAdornment={
          <InputAdornment position='end'>
            {verified ? (
              <CheckCircleIcon
                sx={{ color: '#00CECF', cursor: 'pointer' }}
                onClick={() => setVerified(false)}
              />
            ) : (
              <CheckCircleOutlineIcon
                sx={{ color: '#878787', cursor: 'pointer' }}
                onClick={() => setVerified(true)}
              />
            )}
          </InputAdornment>
        }
        value={value}
        onChange={() => setValue(value)}
      />
      {error !== '' && <QuickStartErrorText error={error} />}
    </Stack>
  );
};

export default CompanyNameTextField;
